import { render } from "./VehicleBox.vue?vue&type=template&id=f0c75dde"
import script from "./VehicleBox.vue?vue&type=script&lang=js"
export * from "./VehicleBox.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__